export default function AvoidListIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.2229 15.7362C17 15.7362 18.125 9.15625 21.1875 10.375C20.125 14.5312 18.1901 22.7745 12.8708 23.0212C5.75182 23.3514 3.84905 16.7733 4.3126 11.7499C4.56426 9.02266 5.68389 7.32833 7.06654 8.28745C7.11551 4.78465 9.40399 2.98578 10.6074 4.50403C11.2359 1.28917 14.4628 1.64508 13.7784 4.79676C14.6748 3.05648 17.0981 2.67775 16.7593 5.0718L16.7583 5.07896C16.0922 9.7871 15.2505 15.7362 16.2229 15.7362Z"
        fill="#FB6434"
      />
      <path
        d="M13.7784 4.79676C14.6748 3.05648 17.0981 2.67775 16.7593 5.0718C16.0931 9.78107 15.25 15.7362 16.2229 15.7362C17 15.7362 18.125 9.15625 21.1875 10.375C20.125 14.5312 18.1901 22.7745 12.8708 23.0212C5.75182 23.3514 3.84905 16.7733 4.3126 11.7499C4.56426 9.02266 5.68389 7.32833 7.06654 8.28745M13.7784 4.79676C14.4628 1.64508 11.2359 1.28917 10.6074 4.50403M13.7784 4.79676C13.073 7.33292 12.8635 10.8757 12.6573 13.1365M10.6074 4.50403C10.2068 6.55356 9.92753 9.80398 10.0076 13.0838M10.6074 4.50403C9.40399 2.98578 7.11551 4.78465 7.06654 8.28745M7.06654 8.28745C7.04831 9.59186 6.88704 11.8121 7.24873 14.9081"
        stroke="#2B2F38"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
